import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    submit: 'Create Task',
    title: 'Confirm',
    taskName: 'Task name',
    execute: 'Execute',
    when: 'When',
    firstExecution: 'First execution at:<br/> <b>{value}</b>',
    at: '{value, time, ::dd MMMM yyyy} at {value, time, ::hh:mm a}',
    then: 'And then:<br/> <b>{value}</b>',
    now: 'from now on',
  },
};
